export const openCenteredPopup = (url: string, title: string, width: number, height: number) => {
  // Get the window position and dimensions, accounting for dual monitors
  const systemZoom = width / window.screen.availWidth;
  const left = (window.innerWidth - width) / 2 / systemZoom + window.screenLeft;
  const top = (window.innerHeight - height) / 2 / systemZoom + window.screenTop;

  // 'popup=yes' is the modern flag, and we set the calculated dimensions.
  const windowFeatures = `
    width=${width / systemZoom},
    height=${height / systemZoom},
    top=${top},
    left=${left},
    popup=yes
  `.replace(/\s/g, "");

  const newWindow = window.open(url, title, windowFeatures);

  // @ts-ignore
  if (window.focus && newWindow) {
    newWindow.focus();
  }

  return newWindow;
};
